import { ROUTES } from 'app/utils/constants/paths';

// Rutas con un secreto en el path: el JWT del relevo de sesión o el código del mando a distancia.
// Las de Edelvives son las mismas cadenas, así que basta con las de app (lo comprueba el test).
const SECRET_ROUTES: string[] = [ROUTES.AUTH_LOGIN_TOKEN, ROUTES.DEEPLINK_TOKEN, ROUTES.OIDC_CALLBACK, ROUTES.SAML_CALLBACK, ROUTES.REMOTE];
// Rutas fijas con la forma de una secreta: su segmento final es una palabra, no un token.
const LITERAL_ROUTES: string[] = [ROUTES.SAML_ERROR];

function toSegments(route: string): string[] {
  return route.split('/').slice(1);
}

const SECRET_PATTERNS = SECRET_ROUTES.map(toSegments);
const LITERAL_PATTERNS = LITERAL_ROUTES.map(toSegments);

function matchesAt(segments: string[], pattern: string[], start: number): boolean {
  return pattern.every((part, offset) => {
    const segment = segments[start + offset];
    return part.startsWith(':') ? Boolean(segment) : part === segment;
  });
}

function redactPattern(segments: string[], pattern: string[]): string[] {
  for (let start = 1; start + pattern.length <= segments.length; start++) {
    const isLiteral = LITERAL_PATTERNS.some((literal) => matchesAt(segments, literal, start));
    if (!isLiteral && matchesAt(segments, pattern, start)) {
      const redacted = [...segments];
      pattern.forEach((part, offset) => {
        if (part.startsWith(':')) redacted[start + offset] = part;
      });
      return redacted;
    }
  }
  return segments;
}

/**
 * Sustituye por su patrón (`/auth/login/:token`) el segmento secreto de la ruta. Se busca en
 * cualquier posición, no desde el principio como `matchPath`, para que valga bajo el `basename`
 * (PUBLIC_URL): redactar de más solo empobrece el dato; de menos, mandaría el token a Athena.
 */
export function redactRouteSecrets(pathname: string): string {
  return SECRET_PATTERNS.reduce((segments, pattern) => redactPattern(segments, pattern), pathname.split('/')).join('/');
}
